module.exports = __webpack_public_path__ + "static/media/car-2-sunnybank.02ecfc42.png";